export const REMOVE_SECTION_MODAL_NAME = 'REMOVE_SECTION_MODAL';
